import React from 'react';

const PhoneInput = ({ className = '', value, onChange, error = '' }) => {
    /**
     * Formats a raw string of numbers into (XXX) XXX-XXXX format.
     */
    const formatPhoneNumber = (input) => {
        // Strip all non-digit characters from the input
        const cleaned = ('' + input).replace(/\D/g, '');

        // Use a regex to match the first 10 digits into three groups
        const match = cleaned.match(/^(\d{0,3})?(\d{0,3})?(\d{0,4})?$/);

        if (match) {
            // Combine the matched groups with the desired formatting
            const part1 = match[1] ? `(${match[1]}` : '';
            const part2 = match[2] ? `) ${match[2]}` : '';
            const part3 = match[3] ? `-${match[3]}` : '';

            // Handle partial input display gracefully
            if (part1 && !part2 && cleaned.length > 3) {
                return `(${match[1]}) ${cleaned.substring(3)}`;
            }
            if (part2 && !part3 && cleaned.length > 6) {
                return `(${match[1]}) ${match[2]}-${cleaned.substring(6)}`;
            }

            return `${part1}${part2}${part3}`;
        }

        return input;
    };

    /**
     * Handles user input, enforces a 10-digit limit, and updates the parent component's state.
     */
    const handleInput = (e) => {
        // Get only the digits from the input value
        let rawValue = e.target.value.replace(/\D/g, '');

        // **Enforce a maximum length of 10 digits**
        if (rawValue.length > 10) {
            rawValue = rawValue.substring(0, 10);
        }

        // Send the raw numeric value (up to 10 digits) to the parent component
        onChange(rawValue);
    };

    return (
        <>
            <div className={`w-full relative flex items-center gap-2 ${className}`}>
                <span className='font-medium'>+1</span>
                <input
                    type='tel'
                    autoComplete='off'
                    inputMode='numeric'
                    value={formatPhoneNumber(value || '')}
                    onChange={handleInput}
                    className={`w-full px-0 py-2  bg-transparent  border-gray-300  focus:outline-none focus:ring-0
                    ${error ? 'border-red-500' : 'border-gray-300'} 
                    `}
                />
            </div>
            {error && <p className='mt-1 text-xs text-red-500'>{error}</p>}
        </>
    );
};

export default PhoneInput;
